import { definePanel } from '@/app/definePanel';
import { AiSearchIcon } from '@/components/occurra/icons/AiSearchIcon';
import { EventsIcon } from '@/components/occurra/icons/EventsIcon';
import { ObjectsIcon } from '@/components/occurra/icons/ObjectsIcon';
import { VideoSearchIcon } from '@/components/occurra/icons/VideoSearchIcon';
import { AiSearchPanelTab } from '@/types/aiSearch';
import { PanelMode, PanelTheme } from '@/types/panels';

export default definePanel({
    id: 'ai_search',
    title: 'AI Search (experimental)',
    description: 'Ask in your own words. Objects, events and video moments in one search.',
    icon: AiSearchIcon,
    launcherTabs: [
        {
            key: AiSearchPanelTab.Ask,
            label: 'AI Search',
            description: 'Ask in your own words. Objects, events and video moments in one search.',
            icon: AiSearchIcon,
            props: { aiSearchTab: AiSearchPanelTab.Ask },
        },
        {
            key: AiSearchPanelTab.Objects,
            label: 'Objects',
            description: 'People, faces and vehicles the agents found. Search them by look.',
            icon: ObjectsIcon,
            props: { aiSearchTab: AiSearchPanelTab.Objects },
        },
        {
            key: AiSearchPanelTab.Events,
            label: 'Events',
            description: 'What the agents reported. Filter by camera, type and rating.',
            icon: EventsIcon,
            props: { aiSearchTab: AiSearchPanelTab.Events },
        },
        {
            key: AiSearchPanelTab.Video,
            label: 'Video search',
            description: 'Describe a scene. The archive answers with the moments that match.',
            icon: VideoSearchIcon,
            props: { aiSearchTab: AiSearchPanelTab.Video },
        },
    ],
    // A browse list like Objects, Events and Video search: it keeps its width, and the
    // preview beside it fills the rest.
    width: { min: 480, default: 480, max: Infinity, fill: false },
    modes: [PanelMode.View],
    themes: PanelTheme.Any,
    // After Video search in the nav, at the end of the search family.
    order: 4.45,
    // The tabs are the header, as in the Objects panel.
    isHeaderless: true,
    // The page's camera, which the camera filter follows while the operator locks it.
    urlSyncedProps: ['cameraId'],
});
